import React, { useState } from 'react';
import { Container, Header, Content, Sidebar } from 'rsuite';
import RenderRoutes from '../../Routes/renderroutes'
import INDIVIDUAL_ROUTES from '../../Routes/individualroutes';
import PublicIndividualSidebar from '../Individual/Sidebar/Sidebar';
import PublicTopNavbar from '../Individual/TopNavbar/TopNavbar'
import { useEffect } from 'react';


function PublicIndividual(props) {
    const [expanded, setExpanded] = useState(window.innerWidth > 820);
    useEffect(() => {
        window.matchMedia("(min-width:820px)").addEventListener("change", (e) => { setExpanded(e.matches) })
    }, [])
    return (
        <Container>
            <Sidebar width={expanded ? 260 : 56}>
                <PublicIndividualSidebar isBoardMember={props.isBoardMember} expanded={expanded} />
            </Sidebar>
            <Container>
                <Header>
                    <PublicTopNavbar />
                </Header>
                <Content className="mainContent">
                    <RenderRoutes routes={INDIVIDUAL_ROUTES} />
                </Content>
            </Container>
        </Container>
    );
}

export default PublicIndividual;